export const DEFAULT = Object.freeze({
  COLUMN_WIDTH: '125px',
});
